import React from 'react';

import { makeUrlParamsFromPath } from 'Internals/graph';

import SesamLink from 'Common/Links/SesamLink';

const HOP_IDENTIFIER = '---';

export const PathRenderer: React.FC<{ path: string[]; subId: string }> = ({ path, subId }) => {
  const string = path.reduce((acc, curr, idx, arr) => {
    if (curr === HOP_IDENTIFIER) {
      return acc;
    }

    return arr[idx - 1] === HOP_IDENTIFIER ? acc + ' ⤑ ' + curr : acc + ' ⭢ ' + curr;
  });

  const link = `/subscription/${subId}/flows/flow?${makeUrlParamsFromPath(path)}`;

  return (
    <SesamLink title={string} to={link} className="primitive-link">
      {string}
    </SesamLink>
  );
};
